module.exports = __webpack_public_path__ + "img/new_spotd8.6493e590.gif";